<template>
  <section>
    <p class="title is-1">Realizar abono</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='router-link' to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item tag='router-link'
        :to="{ name: 'AbonosComponent', params: { id: this.$route.params.id } }">Abonos</b-breadcrumb-item>
      <b-breadcrumb-item active>Realizar abono</b-breadcrumb-item>
    </b-breadcrumb>
    <p class="is-size-5 has-text-weight-semibold">
      Deuda total: ${{ formatoMonto(porPagar) }}
    </p>
    <hr class="my-2">
    <b-switch class="mb-3" v-model="liquidar" @input="fijarMonto">
      Liquidar deuda total
    </b-switch>
    <form @submit.prevent="onRegistrar">
      <b-field label="Monto a abonar">
        <b-input type="number" step="0.01" v-model="monto" placeholder="Introduce el monto a abonar..."
          icon="currency-usd" :max="porPagar" :readonly="liquidar" required></b-input>
      </b-field>
      <b-field label="Método de pago">
        <b-select class="wide" placeholder="Seleccionar..." icon="tag-multiple" v-model="idMetodo" required>
          <option v-for="metodo in metodos" :key="metodo.id" :value="metodo.id">
            {{ metodo.nombre }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Origen" v-if="!esSimple && idMetodo">
        <b-input type="text" name="origen" v-model="origen" placeholder="Origen del pago" icon="account"
          required></b-input>
      </b-field>
      <b-field class="mt-3" label="Esta factura se genera en">
        <b-select class="wide" placeholder="Seleccionar..." icon="receipt" v-model="moneda" required
          @input="manejarMoneda">
          <option key="usd" value="usd">Dólares</option>
          <option key="bs" value="bs">Bolívares</option>
        </b-select>
      </b-field>
      <hr class="mb-2 mt-4">
      <p class="is-size-5 has-text-weight-semibold">
        Restante después del abono: ${{ formatoMonto(restante) }}
      </p>
      <div class="buttons has-text-centered mt-5">
        <b-button native-type="submit" type="is-primary" icon-left="check" :loading="cargando" :disabled="cargando">
          Registrar
        </b-button>
        <b-button type="is-dark" icon-left="cancel" tag="router-link"
          :to="{ name: 'AbonosComponent', params: { id: this.$route.params.id } }">Cancelar</b-button>
      </div>
    </form>
<b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
    <!-- Modal for selecting local -->
    <b-modal v-model="abrirModalLocal" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
      aria-label="Modal Seleccionar Local" close-button-aria-label="Close" aria-modal>
      <div class="modal-card" style="width: 320px">
        <section class="modal-card-body">
          <b-field class="mt-3" label="Local emisor">
            <b-select class="wide" placeholder="Seleccionar..." v-model="local" required>
              <option value="jiro">Jirosushi Prime</option>
              <option value="ccs">Oferta Caracas</option>
              <option value="prime">Food Prime</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button label="Continuar" type="is-primary" @click="confirmarLocal" :disabled="!local" />
        </footer>
      </div>
    </b-modal>
   </section>
</template>
<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
  name: 'RealizarAbono',

  data: () => ({
    moneda: 'usd',
    cargando: false,
    metodos: [],
    porPagar: null,
    origen: null,
    simple: null,
    monto: null,
    idMetodo: null,
    liquidar: false,
    local: null,
    abrirModalLocal: false,
    abonoId: null,
    // Clave de idempotencia del formulario: un mismo abono se manda con la misma clave
    // hasta que se registra bien, para que un reintento por internet no lo duplique.
    idempotencia: null,
  }),

  mounted ()
  {
    this.idempotencia = this.generarClaveIdempotencia()
    this.obtenerDatos()
  },

  methods: {
    /**
     * Genera una clave única para este formulario.
     * crypto.randomUUID solo existe en contexto seguro (HTTPS o localhost): el fallback
     * cubre el caso de servir la app por http en una IP de la red local.
     */
    generarClaveIdempotencia ()
    {
      if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
      }

      return 'abono-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12)
    },
    fijarMonto ()
    {
      if (this.liquidar) {
        this.monto = this.porPagar.toFixed(2)
      } else {
        this.monto = null
      }
    },

    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    manejarMoneda ()
    {
      this.$emit('actualizar', 'moneda', this.moneda)
    },

    async obtenerDatos ()
    {
      this.cargando = true

      const porPagarPromise = HttpService.obtenerConConsultas('ventas.php', {
        accion: 'por_pagar',
        id: this.$route.params.id,
      })

      const metodosPromise = HttpService.obtenerConConsultas('metodos.php', {
        accion: 'obtener'
      })

      const [porPagar, metodos] = await Promise.all([
        porPagarPromise, metodosPromise
      ])

      this.porPagar = Number(porPagar)
      this.metodos = metodos
      this.cargando = false
    },

     async onRegistrar ()
     {
       // Un clic = un envío. Sin esta guarda, dos clics o dos Enter rápidos (el form tiene
       // @submit.prevent) mandan dos peticiones y crean dos abonos.
       if (this.cargando) return

       this.cargando = true

       try {
         let tasa = null

         if (this.moneda === 'bs') {
           const resultado = await HttpService.registrar('ventas.php', {
             accion: 'obtener_tasa'
           })

           tasa = resultado && resultado.id ? resultado.id : null
         }

         const payload = {
           accion: 'realizar_abono',
           abono: {
             monto: this.monto,
             idCuenta: this.$route.params.id,
             idTasa: tasa,
             // Clave estable: si la red corta y el usuario reintenta, el servidor devuelve
             // el abono ya registrado en vez de crear otro.
             idempotencia: this.idempotencia,
           },
         }

         if (this.esSimple) {
           payload.abono.simple = this.idMetodo
         } else {
           payload.abono.idMetodo = this.idMetodo
           payload.abono.origen = this.origen
         }

         const resultado = await HttpService.registrar('ventas.php', payload)

         if (!resultado || resultado.success !== true) {
           this.$buefy.toast.open({
             type: 'is-danger',
             message: (resultado && resultado.error) || 'No se pudo registrar el abono.',
             duration: 8000,
           })
           return
         }

         // El API responde el id del abono (antes el front leía resultado.id y quedaba en
         // undefined, así que el local emisor nunca se asociaba al abono).
         this.abonoId = resultado.id

         if (resultado.duplicado) {
           this.$buefy.toast.open({
             type: 'is-warning',
             message: 'Este abono ya estaba registrado: no se duplicó.',
             duration: 8000,
           })
         } else {
           this.$buefy.toast.open({
             type: 'is-info',
             message: 'Abono registrado con éxito.'
           })
         }

         // Ya quedó guardado: clave nueva para el próximo abono.
         this.idempotencia = this.generarClaveIdempotencia()
         this.abrirModalLocal = true
       } catch (error) {
         // Timeout o caída de red: NO se sabe si el abono quedó guardado. Se conserva la
         // misma clave para que un reintento no duplique nada.
         this.$buefy.toast.open({
           type: 'is-danger',
           message: error && error.message
             ? error.message
             : 'No se pudo confirmar el abono. Revisa la lista antes de repetir.',
           duration: 10000,
         })
       } finally {
         // Sin el finally, un fallo dejaba el overlay de carga puesto para siempre.
         this.cargando = false
       }
     },

     confirmarLocal ()
     {
       // Store the selected local in localStorage with abono id as key
       if (this.abonoId && this.local) {
         localStorage.setItem('abono-local-' + this.abonoId, this.local)
       }
       this.abrirModalLocal = false
       this.$router.push({
         name: 'AbonosComponent',
         params: { id: this.$route.params.id }
       })
     },
  },

  computed: {
    esSimple ()
    {
      return typeof this.idMetodo === 'string'
    },
    restante ()
    {
      return this.porPagar - Number(this.monto)
    }
  }
}
</script>

<style>
input[readonly].input {
  background-color: whitesmoke;
  cursor: default;
  pointer-events: none;
  user-select: none;
}
</style>
